import { all, takeLeading, call, put } from '@redux-saga/core/effects';
import axios from 'axios';

import { ERROR } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';

import { requestViewAllCurrencyCodes } from './currency-code.actions';
import { getViewAllCurrencyCodesRequest } from './currency-code.endpoints';

import { addSystemNotice, addSpinner, removeSpinner } from '../../slices/system/system.slice';
import { setCurrencyCodes } from '../../slices/currency/currency.slice';

export function* performViewAllCurrencyCodesRequest() {
  try {
    yield put(addSpinner('Retrieving currency codes'));

    const [endpoint, options] = getViewAllCurrencyCodesRequest();

    const { data } = yield call(axios, endpoint, options);

    yield put(setCurrencyCodes(data.currencyCodes));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Retrieving currency codes'));
  }
}

export function* watchForViewAllCurrencyCodesRequest() {
  yield takeLeading(requestViewAllCurrencyCodes.type, performViewAllCurrencyCodesRequest);
}

export default function* currencyCodeSaga() {
  yield all([watchForViewAllCurrencyCodesRequest()]);
}
